import React from "react";
import {Backdrop, Box, CircularProgress, Table, TableContainer} from "@mui/material";

const KayakTable = ({loading, selectedTab, headerComponent: HeaderComponent, bodyComponent: BodyComponent }) => {
    return (
        <Box style={{ position: "relative", overflowX: 'hidden' }}>
            <Backdrop
                sx={{
                    color: '#fff',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    opacity: '0.25 !important',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loading?.multipliersMenu?.[selectedTab] === true}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <TableContainer
                sx={{
                    backgroundColor: "white",
                    marginTop: "0px",
                    paddingTop: "0px",
                    border: "none",
                    boxShadow: "none",
                    borderBottomLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                    marginBottom: "10px"
                }}
            >
                <Table sx={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                    <HeaderComponent />
                    <BodyComponent />
                </Table>
            </TableContainer>
        </Box>
    );
};

export default KayakTable;
